exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ForgotPasswordForm-description-nuQvV{\n    color:var(--second-font-color);\n}", ""]);

// exports
exports.locals = {
	"description": "ForgotPasswordForm-description-nuQvV"
};